<section class="post-header">
    <div *ngIf="prevPage.hasHistory()" class="back" (click)="onClickBack()">
        <em class="icon-left_small"></em><span class="hide-on-mobile">Back</span>
    </div>
    <div class="title-element">
        <span class="truncate-paragraph-ellipsis line-clamp-2">{{reportTitle}}</span>
    </div>
</section>
<div *ngIf="!htmlReport" class="loading-container">
  <app-progress-bar-circular/>
</div>
<app-generic-toolbar
  *ngIf="htmlReport && toolbarOptions[0].getOptions().length > 0"
  [toolbarOptions]="toolbarOptions"
  [addRightMargin]="true">
</app-generic-toolbar>
<div *ngIf="downLoadInProgress" class="downloading-spinner">
  <app-progress-bar-circular></app-progress-bar-circular>
  <div class="message">Preparing your download. This may take a few minutes...</div>
</div>
<app-hygraph
  *ngIf="htmlReport"
  [reportTitle]="reportTitle"
  [htmlReport]="htmlReport"
  [lockedMessage]="lockedMessage"
  [fitWidth]="fitWidth"
  [selectedStage]="selectedStage"
  [isContentLoading]="isContentLoading"

  (stageChange)="handleStageChange($event)"
  #hygraph
></app-hygraph>
<iframe #invisibleIframe title="invisible-iframe"></iframe>
